import { render, staticRenderFns } from "./institutionTable.vue?vue&type=template&id=7c8eceea&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./institutionTable.vue?vue&type=style&index=0&id=7c8eceea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8eceea",
  null
  
)

export default component.exports